import cashInOutActionTypes from "./cash-in-out-types";

const intitialState = {
  reasonCodes: [],
  employees: [],
  warehouses: [],
  pointOfSales: [],
  sessionKeyUser: {},
  storeRegions: [],
};

const cashInOutReducer = (state = intitialState, { type, payload }) => {
  switch (type) {
    case cashInOutActionTypes.GET_EMPLOYEES_SUCCESS:
      return {
        ...state,
        employees: payload,
      };

    case cashInOutActionTypes.GET_EMPLOYEES_FAILED:
      return {
        ...state,
        employees: [],
      };

    case cashInOutActionTypes.GET_POINT_OF_SALE_SUCCESS:
      return {
        ...state,
        pointOfSales: payload,
      };

    case cashInOutActionTypes.GET_POINT_OF_SALE_FAILED:
      return {
        ...state,
        pointOfSales: [],
      };

    case cashInOutActionTypes.GET_REASON_CODE_SUCCESS:
      return {
        ...state,
        reasonCodes: payload,
      };

    case cashInOutActionTypes.GET_REASON_CODE_FAILED:
      return {
        ...state,
        reasonCodes: [],
      };

    case cashInOutActionTypes.GET_WAREHOUSE_SUCCESS:
      return {
        ...state,
        warehouses: payload,
      };

    case cashInOutActionTypes.GET_WAREHOUSE_FAILED:
      return {
        ...state,
        warehouses: [],
      };

    case cashInOutActionTypes.GET_SESSION_USER_SUCCESS:
      return {
        ...state,
        sessionKeyUser: payload,
      };

    case cashInOutActionTypes.GET_SESSION_USER_FAILED:
      return {
        ...state,
        sessionKeyUser: {},
      };

    case cashInOutActionTypes.GET_STORE_REGIONS_SUCCESS:
      return {
        ...state,
        storeRegions: payload,
      };

    case cashInOutActionTypes.GET_STORE_REGIONS_FAILED:
      return {
        ...state,
        storeRegions: [],
      };

    default:
      return state;
  }
};

export default cashInOutReducer;
